var map = {
	"./2021-07-10-redlining/ScatterPlot": [
		39806,
		9,
		3645,
		3856,
		8490,
		8294,
		9806
	],
	"./2021-07-10-redlining/ScatterPlot.js": [
		39806,
		9,
		3645,
		3856,
		8490,
		8294,
		9806
	],
	"./2021-07-10-redlining/data": [
		95936,
		9,
		5936
	],
	"./2021-07-10-redlining/data.js": [
		95936,
		9,
		5936
	],
	"./2021-07-10-redlining/dataKey": [
		98288,
		9,
		5469,
		8288
	],
	"./2021-07-10-redlining/dataKey.js": [
		98288,
		9,
		5469,
		8288
	],
	"./2021-07-10-redlining/map-materials/coordinates": [
		55093,
		9,
		5093
	],
	"./2021-07-10-redlining/map-materials/coordinates.js": [
		55093,
		9,
		5093
	],
	"./2021-07-10-redlining/map-materials/map": [
		46099,
		9,
		1002,
		6099
	],
	"./2021-07-10-redlining/map-materials/map.js": [
		46099,
		9,
		1002,
		6099
	],
	"./2021-07-10-redlining/scatterplots/ChemPlot": [
		43860,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		3860
	],
	"./2021-07-10-redlining/scatterplots/ChemPlot.js": [
		43860,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		3860
	],
	"./2021-07-10-redlining/scatterplots/EconPlot": [
		195,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		195
	],
	"./2021-07-10-redlining/scatterplots/EconPlot.js": [
		195,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		195
	],
	"./2021-07-10-redlining/scatterplots/HealthPlot": [
		72606,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		2606
	],
	"./2021-07-10-redlining/scatterplots/HealthPlot.js": [
		72606,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		2606
	],
	"./2021-07-10-redlining/scatterplots/WaterPlot": [
		68030,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		8030
	],
	"./2021-07-10-redlining/scatterplots/WaterPlot.js": [
		68030,
		9,
		3645,
		3856,
		8490,
		8294,
		5469,
		8030
	],
	"./2021-08-22-berkeley-guide-orientation/GuideCoordinates": [
		1585,
		9,
		1585
	],
	"./2021-08-22-berkeley-guide-orientation/GuideCoordinates.js": [
		1585,
		9,
		1585
	],
	"./2021-08-22-berkeley-guide-orientation/GuideMap": [
		14185,
		9,
		1002,
		4185
	],
	"./2021-08-22-berkeley-guide-orientation/GuideMap.js": [
		14185,
		9,
		1002,
		4185
	],
	"./2021-11-22-rent-shelter/AlamedaShelter": [
		33283,
		9,
		3645,
		3856,
		8490,
		5791,
		3283
	],
	"./2021-11-22-rent-shelter/AlamedaShelter.js": [
		33283,
		9,
		3645,
		3856,
		8490,
		5791,
		3283
	],
	"./2021-11-22-rent-shelter/BerkeleyAlamedaLunch": [
		89020,
		9,
		3645,
		3856,
		8490,
		9986,
		9020
	],
	"./2021-11-22-rent-shelter/BerkeleyAlamedaLunch.js": [
		89020,
		9,
		3645,
		3856,
		8490,
		9986,
		9020
	],
	"./2021-11-22-rent-shelter/BerkeleyAlamedaRent": [
		79931,
		9,
		3645,
		3856,
		8490,
		5791,
		9931
	],
	"./2021-11-22-rent-shelter/BerkeleyAlamedaRent.js": [
		79931,
		9,
		3645,
		3856,
		8490,
		5791,
		9931
	],
	"./2021-11-22-rent-shelter/BerkeleyShelter": [
		25624,
		9,
		3645,
		3856,
		8490,
		5791,
		5624
	],
	"./2021-11-22-rent-shelter/BerkeleyShelter.js": [
		25624,
		9,
		3645,
		3856,
		8490,
		5791,
		5624
	],
	"./2021-11-22-rent-shelter/rentShelterData": [
		13287,
		9,
		3287
	],
	"./2021-11-22-rent-shelter/rentShelterData.js": [
		13287,
		9,
		3287
	],
	"./2021-11-23-hate-crimes/HateBar": [
		18820,
		9,
		3645,
		3856,
		8490,
		8820
	],
	"./2021-11-23-hate-crimes/HateBar.js": [
		18820,
		9,
		3645,
		3856,
		8490,
		8820
	],
	"./2021-11-23-hate-crimes/HateLine": [
		22856,
		9,
		3645,
		3856,
		8490,
		9986,
		2856
	],
	"./2021-11-23-hate-crimes/HateLine.js": [
		22856,
		9,
		3645,
		3856,
		8490,
		9986,
		2856
	],
	"./2021-11-23-hate-crimes/data": [
		31033,
		9,
		1033
	],
	"./2021-11-23-hate-crimes/data.js": [
		31033,
		9,
		1033
	],
	"./2022-01-21-exodus/BerkACBlackCensus": [
		33871,
		9,
		3871
	],
	"./2022-01-21-exodus/BerkACBlackCensus.js": [
		33871,
		9,
		3871
	],
	"./2022-01-21-exodus/BlackEnrollmentBUSD": [
		3184,
		9,
		3645,
		3856,
		8490,
		5791,
		3184
	],
	"./2022-01-21-exodus/BlackEnrollmentBUSD.js": [
		3184,
		9,
		3645,
		3856,
		8490,
		5791,
		3184
	],
	"./2022-01-21-exodus/BlackPopulationCensus": [
		54436,
		9,
		3645,
		3856,
		8490,
		5791,
		4436
	],
	"./2022-01-21-exodus/BlackPopulationCensus.js": [
		54436,
		9,
		3645,
		3856,
		8490,
		5791,
		4436
	],
	"./2022-01-21-exodus/berkACData": [
		39214,
		9,
		9214
	],
	"./2022-01-21-exodus/berkACData.js": [
		39214,
		9,
		9214
	],
	"./2022-01-21-exodus/district-map-materials/districtData": [
		25157,
		9,
		5157
	],
	"./2022-01-21-exodus/district-map-materials/districtData.js": [
		25157,
		9,
		5157
	],
	"./2022-01-21-exodus/district-map-materials/districtMap": [
		85741,
		9,
		1002,
		5157,
		5741
	],
	"./2022-01-21-exodus/district-map-materials/districtMap.js": [
		85741,
		9,
		1002,
		5157,
		5741
	],
	"./2022-03-17-gym-pac-12/GymBars": [
		63959,
		9,
		3645,
		3856,
		8490,
		8294,
		3959
	],
	"./2022-03-17-gym-pac-12/GymBars.js": [
		63959,
		9,
		3645,
		3856,
		8490,
		8294,
		3959
	],
	"./2022-03-17-gym-pac-12/GymBeam": [
		87859,
		9,
		3645,
		3856,
		8490,
		8294,
		7859
	],
	"./2022-03-17-gym-pac-12/GymBeam.js": [
		87859,
		9,
		3645,
		3856,
		8490,
		8294,
		7859
	],
	"./2022-03-17-gym-pac-12/GymFloor": [
		69959,
		9,
		3645,
		3856,
		8490,
		8294,
		9959
	],
	"./2022-03-17-gym-pac-12/GymFloor.js": [
		69959,
		9,
		3645,
		3856,
		8490,
		8294,
		9959
	],
	"./2022-03-17-gym-pac-12/GymTotals": [
		31618,
		9,
		3645,
		3856,
		8490,
		8294,
		1618
	],
	"./2022-03-17-gym-pac-12/GymTotals.js": [
		31618,
		9,
		3645,
		3856,
		8490,
		8294,
		1618
	],
	"./2022-03-17-gym-pac-12/GymVault": [
		21484,
		9,
		3645,
		3856,
		8490,
		8294,
		1484
	],
	"./2022-03-17-gym-pac-12/GymVault.js": [
		21484,
		9,
		3645,
		3856,
		8490,
		8294,
		1484
	],
	"./2022-03-17-gym-pac-12/gymData": [
		19096,
		9,
		9096
	],
	"./2022-03-17-gym-pac-12/gymData.js": [
		19096,
		9,
		9096
	],
	"./2022-04-20-stem-enrollment/STEMLine": [
		42463,
		9,
		3645,
		3856,
		8490,
		9986,
		2463
	],
	"./2022-04-20-stem-enrollment/STEMLine.js": [
		42463,
		9,
		3645,
		3856,
		8490,
		9986,
		2463
	],
	"./2022-04-20-stem-enrollment/STEMLineData": [
		93146,
		9,
		3146
	],
	"./2022-04-20-stem-enrollment/STEMLineData.js": [
		93146,
		9,
		3146
	],
	"./2022-05-04-1921-timeline/1921Timeline": [
		99615,
		9,
		9401,
		9615
	],
	"./2022-05-04-1921-timeline/1921Timeline.js": [
		99615,
		9,
		9401,
		9615
	],
	"./2022-09-15-study-abroad/StudyAbroadCoordinates": [
		72265,
		9,
		2265
	],
	"./2022-09-15-study-abroad/StudyAbroadCoordinates.js": [
		72265,
		9,
		2265
	],
	"./2022-09-15-study-abroad/StudyAbroadMap": [
		35555,
		9,
		1002,
		5555
	],
	"./2022-09-15-study-abroad/StudyAbroadMap.js": [
		35555,
		9,
		1002,
		5555
	],
	"./2022-09-22-artifacts/ArtifactsBarChart": [
		82532,
		9,
		3645,
		3856,
		8490,
		5080,
		2532
	],
	"./2022-09-22-artifacts/ArtifactsBarChart.js": [
		82532,
		9,
		3645,
		3856,
		8490,
		5080,
		2532
	],
	"./2022-09-22-artifacts/ArtifactsPieChart": [
		35326,
		9,
		3645,
		3856,
		130,
		5326
	],
	"./2022-09-22-artifacts/ArtifactsPieChart.js": [
		35326,
		9,
		3645,
		3856,
		130,
		5326
	],
	"./2022-09-22-artifacts/artifactsData": [
		41959,
		9,
		1959
	],
	"./2022-09-22-artifacts/artifactsData.js": [
		41959,
		9,
		1959
	],
	"./2022-10-11-hsi/HSIData": [
		25668,
		9,
		5668
	],
	"./2022-10-11-hsi/HSIData.js": [
		25668,
		9,
		5668
	],
	"./2022-10-11-hsi/HSILineChart": [
		46034,
		9,
		3645,
		3856,
		8490,
		9986,
		6034
	],
	"./2022-10-11-hsi/HSILineChart.js": [
		46034,
		9,
		3645,
		3856,
		8490,
		9986,
		6034
	],
	"./2022-11-07-reddit/DailyCommentCount": [
		9801,
		9,
		3645,
		3856,
		8490,
		9986,
		9801
	],
	"./2022-11-07-reddit/DailyCommentCount.js": [
		9801,
		9,
		3645,
		3856,
		8490,
		9986,
		9801
	],
	"./2022-11-07-reddit/PostsPerDayBarChart": [
		18561,
		9,
		3645,
		3856,
		8490,
		8561
	],
	"./2022-11-07-reddit/PostsPerDayBarChart.js": [
		18561,
		9,
		3645,
		3856,
		8490,
		8561
	],
	"./2022-11-07-reddit/PostsPerFlairBarChart": [
		3996,
		9,
		3645,
		3856,
		8490,
		3996
	],
	"./2022-11-07-reddit/PostsPerFlairBarChart.js": [
		3996,
		9,
		3645,
		3856,
		8490,
		3996
	],
	"./2022-11-07-reddit/PostsPerHourBarChart": [
		26746,
		9,
		3645,
		3856,
		8490,
		6746
	],
	"./2022-11-07-reddit/PostsPerHourBarChart.js": [
		26746,
		9,
		3645,
		3856,
		8490,
		6746
	],
	"./2022-11-07-reddit/SubscriberCount": [
		54023,
		9,
		3645,
		3856,
		8490,
		9986,
		4023
	],
	"./2022-11-07-reddit/SubscriberCount.js": [
		54023,
		9,
		3645,
		3856,
		8490,
		9986,
		4023
	],
	"./2022-11-07-reddit/dailyCommentCountData": [
		19608,
		9,
		9608
	],
	"./2022-11-07-reddit/dailyCommentCountData.js": [
		19608,
		9,
		9608
	],
	"./2022-11-07-reddit/postsPerDayData": [
		15888,
		9,
		5888
	],
	"./2022-11-07-reddit/postsPerDayData.js": [
		15888,
		9,
		5888
	],
	"./2022-11-07-reddit/postsPerFlairData": [
		74516,
		9,
		4516
	],
	"./2022-11-07-reddit/postsPerFlairData.js": [
		74516,
		9,
		4516
	],
	"./2022-11-07-reddit/postsPerHourData": [
		80661,
		9,
		661
	],
	"./2022-11-07-reddit/postsPerHourData.js": [
		80661,
		9,
		661
	],
	"./2022-11-07-reddit/subscriberCountData": [
		49084,
		9,
		9084
	],
	"./2022-11-07-reddit/subscriberCountData.js": [
		49084,
		9,
		9084
	],
	"./2022-11-08-busd-gap/GapStackedBarChart": [
		15072,
		9,
		3645,
		3856,
		8490,
		5072
	],
	"./2022-11-08-busd-gap/GapStackedBarChart.js": [
		15072,
		9,
		3645,
		3856,
		8490,
		5072
	],
	"./2022-11-08-busd-gap/gapDataELA": [
		28020,
		9,
		8020
	],
	"./2022-11-08-busd-gap/gapDataELA.js": [
		28020,
		9,
		8020
	],
	"./2022-11-08-busd-gap/gapDataMath": [
		60496,
		9,
		496
	],
	"./2022-11-08-busd-gap/gapDataMath.js": [
		60496,
		9,
		496
	],
	"./2022-11-18-turnover/TurnoverMap": [
		25740,
		9,
		1002,
		5740
	],
	"./2022-11-18-turnover/TurnoverMap.js": [
		25740,
		9,
		1002,
		5740
	],
	"./2022-11-18-turnover/turnoverCoordinates": [
		56623,
		9,
		6623
	],
	"./2022-11-18-turnover/turnoverCoordinates.js": [
		56623,
		9,
		6623
	],
	"./2022-11-22-bargaining/BargainingColorMap": [
		41739,
		9,
		1739
	],
	"./2022-11-22-bargaining/BargainingColorMap.js": [
		41739,
		9,
		1739
	],
	"./2022-11-22-bargaining/BargainingNumberMap": [
		10140,
		9,
		140
	],
	"./2022-11-22-bargaining/BargainingNumberMap.js": [
		10140,
		9,
		140
	],
	"./2022-11-22-bargaining/InfoAR": [
		75926,
		9,
		5926
	],
	"./2022-11-22-bargaining/InfoAR.js": [
		75926,
		9,
		5926
	],
	"./2022-11-22-bargaining/InfoASE": [
		89052,
		9,
		9052
	],
	"./2022-11-22-bargaining/InfoASE.js": [
		89052,
		9,
		9052
	],
	"./2022-11-22-bargaining/InfoPostdocs": [
		32629,
		9,
		2629
	],
	"./2022-11-22-bargaining/InfoPostdocs.js": [
		32629,
		9,
		2629
	],
	"./2022-11-22-bargaining/InfoSR": [
		3815,
		9,
		3815
	],
	"./2022-11-22-bargaining/InfoSR.js": [
		3815,
		9,
		3815
	],
	"./2022-11-22-bargaining/ProposalsAR": [
		85951,
		9,
		5080,
		8364,
		5951
	],
	"./2022-11-22-bargaining/ProposalsAR.js": [
		85951,
		9,
		5080,
		8364,
		5951
	],
	"./2022-11-22-bargaining/ProposalsASE": [
		5221,
		9,
		5080,
		8364,
		5221
	],
	"./2022-11-22-bargaining/ProposalsASE.js": [
		5221,
		9,
		5080,
		8364,
		5221
	],
	"./2022-11-22-bargaining/ProposalsPostdocs": [
		50821,
		9,
		5080,
		8364,
		2629,
		821
	],
	"./2022-11-22-bargaining/ProposalsPostdocs.js": [
		50821,
		9,
		5080,
		8364,
		2629,
		821
	],
	"./2022-11-22-bargaining/ProposalsSR": [
		92891,
		9,
		5080,
		8364,
		2891
	],
	"./2022-11-22-bargaining/ProposalsSR.js": [
		92891,
		9,
		5080,
		8364,
		2891
	],
	"./2022-12-09-kutcher/KutcherTimeline": [
		76692,
		9,
		9401,
		6692
	],
	"./2022-12-09-kutcher/KutcherTimeline.js": [
		76692,
		9,
		9401,
		6692
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 11 Figure Skating Performance.png": [
		73108,
		1,
		3108
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 11 School Dance Performance.png": [
		6132,
		1,
		6132
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 18 High School Graduation.png": [
		93121,
		1,
		3121
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 20 Attending College Class.png": [
		21547,
		1,
		1547
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 21 Attending Blade Rave.png": [
		76467,
		1,
		6467
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 4.png": [
		13097,
		1,
		3097
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 6.png": [
		65793,
		1,
		5793
	],
	"./2022-12-09-kutcher/kutcher-images/Kira Kutcher - Age 8.png": [
		31175,
		1,
		1175
	],
	"./2023-01-31-union-vote/TimeDoctorateBarChart": [
		17379,
		9,
		3645,
		3856,
		8490,
		7379
	],
	"./2023-01-31-union-vote/TimeDoctorateBarChart.js": [
		17379,
		9,
		3645,
		3856,
		8490,
		7379
	],
	"./2023-01-31-union-vote/UnionVoteBarChart": [
		62752,
		9,
		3645,
		3856,
		8490,
		5080,
		2752
	],
	"./2023-01-31-union-vote/UnionVoteBarChart.js": [
		62752,
		9,
		3645,
		3856,
		8490,
		5080,
		2752
	],
	"./2023-01-31-union-vote/timeDoctorateData": [
		48507,
		9,
		8507
	],
	"./2023-01-31-union-vote/timeDoctorateData.js": [
		48507,
		9,
		8507
	],
	"./2023-01-31-union-vote/unionVoteData": [
		69047,
		9,
		9047
	],
	"./2023-01-31-union-vote/unionVoteData.js": [
		69047,
		9,
		9047
	],
	"./2023-03-01-rent-map/UniversityRentMap": [
		47212,
		9,
		1002,
		7212
	],
	"./2023-03-01-rent-map/UniversityRentMap.css": [
		61404,
		9,
		1404
	],
	"./2023-03-01-rent-map/UniversityRentMap.js": [
		47212,
		9,
		1002,
		7212
	],
	"./2023-03-01-rent-map/universityRentData": [
		361,
		9,
		361
	],
	"./2023-03-01-rent-map/universityRentData.js": [
		361,
		9,
		361
	],
	"./2023-03-10-telegraph-pedestrianized/OptionWidths": [
		69029,
		9,
		3645,
		3873,
		9029
	],
	"./2023-03-10-telegraph-pedestrianized/OptionWidths.css": [
		22803,
		9,
		2803
	],
	"./2023-03-10-telegraph-pedestrianized/OptionWidths.js": [
		69029,
		9,
		3645,
		3873,
		9029
	],
	"./2023-03-10-telegraph-pedestrianized/OptionWidths2": [
		29883,
		9,
		3645,
		3873,
		9883
	],
	"./2023-03-10-telegraph-pedestrianized/OptionWidths2.js": [
		29883,
		9,
		3645,
		3873,
		9883
	],
	"./2023-03-10-telegraph-pedestrianized/optionWidthsData": [
		60430,
		9,
		430
	],
	"./2023-03-10-telegraph-pedestrianized/optionWidthsData.js": [
		60430,
		9,
		430
	],
	"./2023-03-10-telegraph-pedestrianized/optionWidthsData2": [
		2990,
		9,
		2990
	],
	"./2023-03-10-telegraph-pedestrianized/optionWidthsData2.js": [
		2990,
		9,
		2990
	],
	"./2023-06-30-warnme/WarnMeHistogram": [
		59583,
		9,
		3645,
		3856,
		8490,
		5080,
		9583
	],
	"./2023-06-30-warnme/WarnMeHistogram.js": [
		59583,
		9,
		3645,
		3856,
		8490,
		5080,
		9583
	],
	"./2023-06-30-warnme/data": [
		82942,
		9,
		2942
	],
	"./2023-06-30-warnme/data.js": [
		82942,
		9,
		2942
	],
	"./2023-12-20-theft/BikeTheftMap": [
		96010,
		9,
		5080,
		1002,
		549,
		9958,
		3094
	],
	"./2023-12-20-theft/BikeTheftMap.css": [
		11574,
		9,
		1574
	],
	"./2023-12-20-theft/BikeTheftMap.js": [
		96010,
		9,
		5080,
		1002,
		549,
		9958,
		3094
	],
	"./2023-12-20-theft/BikeTheftTips": [
		36888,
		9,
		6888
	],
	"./2023-12-20-theft/BikeTheftTips.js": [
		36888,
		9,
		6888
	],
	"./2023-12-20-theft/PopularTheftLocationsBarChart": [
		66864,
		9,
		3645,
		3856,
		8490,
		6864
	],
	"./2023-12-20-theft/PopularTheftLocationsBarChart.js": [
		66864,
		9,
		3645,
		3856,
		8490,
		6864
	],
	"./2023-12-20-theft/TheftsPerHourLineChart": [
		38825,
		9,
		3645,
		3856,
		8490,
		9986,
		8825
	],
	"./2023-12-20-theft/TheftsPerHourLineChart.js": [
		38825,
		9,
		3645,
		3856,
		8490,
		9986,
		8825
	],
	"./2023-12-20-theft/TheftsPerYearBarChart": [
		8274,
		9,
		3645,
		3856,
		8490,
		8274
	],
	"./2023-12-20-theft/TheftsPerYearBarChart.js": [
		8274,
		9,
		3645,
		3856,
		8490,
		8274
	],
	"./2023-12-20-theft/bikeTheftMapData": [
		60687,
		9,
		687
	],
	"./2023-12-20-theft/bikeTheftMapData.js": [
		60687,
		9,
		687
	],
	"./2023-12-20-theft/bikeTheftMapDataByYear": [
		99958,
		9,
		9958
	],
	"./2023-12-20-theft/bikeTheftMapDataByYear.js": [
		99958,
		9,
		9958
	],
	"./2023-12-20-theft/popularTheftLocationsData": [
		58961,
		9,
		8961
	],
	"./2023-12-20-theft/popularTheftLocationsData.js": [
		58961,
		9,
		8961
	],
	"./2023-12-20-theft/theftsPerHourData": [
		97992,
		9,
		7992
	],
	"./2023-12-20-theft/theftsPerHourData.js": [
		97992,
		9,
		7992
	],
	"./2023-12-20-theft/theftsPerYearData": [
		12979,
		9,
		2979
	],
	"./2023-12-20-theft/theftsPerYearData.js": [
		12979,
		9,
		2979
	],
	"./2024-02-18-internal-audit/DepartmentBarChart": [
		43824,
		9,
		3645,
		3856,
		8490,
		3824
	],
	"./2024-02-18-internal-audit/DepartmentBarChart.js": [
		43824,
		9,
		3645,
		3856,
		8490,
		3824
	],
	"./2024-02-18-internal-audit/InternalAuditBarChart": [
		90419,
		9,
		3645,
		3856,
		8490,
		5080,
		419
	],
	"./2024-02-18-internal-audit/InternalAuditBarChart.js": [
		90419,
		9,
		3645,
		3856,
		8490,
		5080,
		419
	],
	"./2024-02-18-internal-audit/departmentBarChartData": [
		73642,
		9,
		3642
	],
	"./2024-02-18-internal-audit/departmentBarChartData.js": [
		73642,
		9,
		3642
	],
	"./2024-02-18-internal-audit/internalAuditData": [
		15670,
		9,
		5670
	],
	"./2024-02-18-internal-audit/internalAuditData.js": [
		15670,
		9,
		5670
	],
	"./2024-02-29-construction/ProjectsByFundingBar": [
		33745,
		9,
		3645,
		3856,
		8490,
		3745
	],
	"./2024-02-29-construction/ProjectsByFundingBar.css": [
		78252,
		9,
		8252
	],
	"./2024-02-29-construction/ProjectsByFundingBar.js": [
		33745,
		9,
		3645,
		3856,
		8490,
		3745
	],
	"./2024-02-29-construction/ProjectsByValuationMap": [
		24622,
		9,
		1002,
		3732,
		4622
	],
	"./2024-02-29-construction/ProjectsByValuationMap.css": [
		85900,
		9,
		5900
	],
	"./2024-02-29-construction/ProjectsByValuationMap.js": [
		24622,
		9,
		1002,
		3732,
		4622
	],
	"./2024-02-29-construction/RHNABarChart": [
		93928,
		9,
		3645,
		3856,
		8490,
		3928
	],
	"./2024-02-29-construction/RHNABarChart.css": [
		4934,
		9,
		4934
	],
	"./2024-02-29-construction/RHNABarChart.js": [
		93928,
		9,
		3645,
		3856,
		8490,
		3928
	],
	"./2024-02-29-construction/data/RHNA_data": [
		94810,
		3,
		4810
	],
	"./2024-02-29-construction/data/RHNA_data.json": [
		94810,
		3,
		4810
	],
	"./2024-02-29-construction/data/berk_construction_by_fund": [
		47752,
		3,
		7752
	],
	"./2024-02-29-construction/data/berk_construction_by_fund.json": [
		47752,
		3,
		7752
	],
	"./2024-02-29-construction/data/permit_data": [
		23732,
		3,
		3732
	],
	"./2024-02-29-construction/data/permit_data.json": [
		23732,
		3,
		3732
	],
	"./2024-04-19-coffee/CoffeeMap": [
		31569,
		9,
		1002,
		2373,
		1576
	],
	"./2024-04-19-coffee/CoffeeMap.css": [
		20429,
		9,
		429
	],
	"./2024-04-19-coffee/CoffeeMap.js": [
		31569,
		9,
		1002,
		2373,
		1576
	],
	"./2024-04-19-coffee/CoffeePricesBarChart": [
		96434,
		9,
		3645,
		3856,
		8490,
		6434
	],
	"./2024-04-19-coffee/CoffeePricesBarChart.css": [
		19296,
		9,
		9296
	],
	"./2024-04-19-coffee/CoffeePricesBarChart.js": [
		96434,
		9,
		3645,
		3856,
		8490,
		6434
	],
	"./2024-04-19-coffee/coffeeData": [
		53878,
		9,
		3878
	],
	"./2024-04-19-coffee/coffeeData.js": [
		53878,
		9,
		3878
	],
	"./2024-05-20-baypass/BayPassCalculator": [
		55206,
		9,
		5080,
		1002,
		6794,
		784,
		2994
	],
	"./2024-05-20-baypass/BayPassCalculator.css": [
		24762,
		9,
		4762
	],
	"./2024-05-20-baypass/BayPassCalculator.js": [
		55206,
		9,
		5080,
		1002,
		6794,
		784,
		2994
	],
	"./2024-05-20-baypass/BayPassRidershipLine": [
		63815,
		9,
		3645,
		3856,
		8490,
		5080,
		9986,
		6794,
		4134,
		122
	],
	"./2024-05-20-baypass/BayPassRidershipLine.css": [
		94024,
		9,
		4024
	],
	"./2024-05-20-baypass/BayPassRidershipLine.js": [
		63815,
		9,
		3645,
		3856,
		8490,
		5080,
		9986,
		6794,
		4134,
		122
	],
	"./2024-05-20-baypass/data/BART_fares": [
		60784,
		3,
		784
	],
	"./2024-05-20-baypass/data/BART_fares.json": [
		60784,
		3,
		784
	],
	"./2024-05-20-baypass/data/BART_lines_ordered_stops": [
		3995,
		3,
		3995
	],
	"./2024-05-20-baypass/data/BART_lines_ordered_stops.json": [
		3995,
		3,
		3995
	],
	"./2024-05-20-baypass/data/BART_ridership": [
		71865,
		3,
		1865
	],
	"./2024-05-20-baypass/data/BART_ridership.json": [
		71865,
		3,
		1865
	],
	"./2024-05-20-baypass/data/BART_stops_by_line_ordered": [
		88041,
		3,
		8041
	],
	"./2024-05-20-baypass/data/BART_stops_by_line_ordered.json": [
		88041,
		3,
		8041
	],
	"./2024-05-20-baypass/data/BART_stops_leaflet": [
		59248,
		3,
		9248
	],
	"./2024-05-20-baypass/data/BART_stops_leaflet.json": [
		59248,
		3,
		9248
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43672;
module.exports = webpackAsyncContext;